import React, { useState } from "react";
import { MdCopyAll } from "react-icons/md";
import { Toast } from "./ToastContext";
import { Update_status_message_qry } from "../status_root/update_status_message";

const CopyUID = ({ id, contentid, title = "Copy" }) => {
  const { Toastshow } = Toast();
  const [copyId, setCopyId] = useState(null);

  const handleCopy = async () => {

    // prevent duplicate copy


    if (!id) {
      Toastshow("Nothing to copy");
      return;
    }
   if (copyId !== contentid) {
           await Update_status_message_qry(contentid, "copy");
    }
      // update firestore

    try {
      await navigator.clipboard.writeText(id);
 

      setCopyId(contentid);

      Toastshow("Copied");

    } catch (err) {
      Toastshow("Failed to copy");
    }
  };

  return (
    <MdCopyAll
      onClick={handleCopy}
      title={title}
      className="icon cursor"
   
    />
  );
};

export default CopyUID;